import React from 'react';
import PropTypes from 'prop-types';

import { weatherIconMap } from '../../../../helpers/constants';

const WeatherReportSummary = ({
  title,
  data,
  labelPastSnowball,
  labelTodaySnowball,
  labelTonightsSnowball,
  labelWindSpeed
}) => {
  const todayForecastData = data.filter(day => day.isToday);
  const todayForecast = { ...todayForecastData }[0];

  return (
    <div className="weather-report-update__summary">
      {!!title && (
        <h2 className="weather-report-update__summary-title">{title}</h2>
      )}
      <p className="weather-report-update__partnership">
        Forecast in partnership with&nbsp;
        <img
          src="/public/AspenSnowmassRedesign/images/content-managed/opensnow.png"
          alt="opensnow"
          loading="lazy"
        />
      </p>
      <div className="weather-report-update__main-container">
        <div className="weather-report-update__container">
          <div className="weather-report-update__main-block">
            <div className="weather-report-update__summary-icon">
              <svg>
                <title>weather</title>
                <use xlinkHref={`#${weatherIconMap[todayForecast.icon]}`} />
              </svg>
            </div>
            <div className="weather-report-update__todays-grid">
              <div className="weather-report-update__todays-block">
                <span className="weather-report-update__font-light">
                  {todayForecast.condition}
                </span>
                <span className="weather-report-update__font-bold">
                  {todayForecast.tempFahrenheit}°F
                </span>
              </div>
              <div className="weather-report-update__todays-block">
                <span className="weather-report-update__font-light">
                  {todayForecast.tempCelsius}°C
                </span>
              </div>
              <div className="weather-report-update__todays-block">
                <span className="weather-report-update__font-bold small">
                  <svg viewBox="0 0 11 16">
                    <title>today list</title>
                    <use xlinkHref="#arrow-up" />
                  </svg>
                  {todayForecast.maxTempFahrenheit}°F
                </span>
              </div>
              <div className="weather-report-update__todays-block">
                <span className="weather-report-update__font-bold small">
                  <svg viewBox="0 0 11 16">
                    <title>today list</title>
                    <use xlinkHref="#arrow-down" />
                  </svg>
                  {todayForecast.minTempFahrenheit}°F
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="weather-report-update__secondary-block">
          <div className="weather-report-update__summary-block">
            <span className="weather-report-update__summary-bold">
              {todayForecast.past24HrSnow}&quot;
            </span>
            <span className="weather-report-update__summary-light">
              {labelPastSnowball}
            </span>
          </div>
          <div className="weather-report-update__summary-block">
            <span className="weather-report-update__summary-bold">
              {todayForecast.todaySnow}&quot;
            </span>
            <span className="weather-report-update__summary-light">
              {labelTodaySnowball}
            </span>
          </div>
          <div className="weather-report-update__summary-block">
            <span className="weather-report-update__summary-bold">
              {todayForecast.tonightSnow}&quot;
            </span>
            <span className="weather-report-update__summary-light">
              {labelTonightsSnowball}
            </span>
          </div>
          <div className="weather-report-update__summary-block">
            <span>
              <b className="weather-report-update__summary-bold">
                {todayForecast.windSpeed}
                <span>mph</span>
              </b>{' '}
              {todayForecast.windDirection}
            </span>
            <span className="weather-report-update__summary-light">
              {labelWindSpeed}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

WeatherReportSummary.propTypes = {
  title: PropTypes.string,
  labelPastSnowball: PropTypes.string.isRequired,
  labelTodaySnowball: PropTypes.string.isRequired,
  labelTonightsSnowball: PropTypes.string.isRequired,
  labelWindSpeed: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
};

export default WeatherReportSummary;
